/* import __COLOCATED_TEMPLATE__ from './preview-settings-modal.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type UserSummary from 'embercom/objects/inbox/user-summary';
import type { PreviewSpoofingSettings } from 'embercom/components/workflows/preview/preview-module';

interface PreviewSettingsModalArgs {
  isOpen: boolean;
  onClose: () => void;
  onSave: (settings: PreviewSpoofingSettings) => void;
  currentBrandId: string | null;
  currentUser?: UserSummary | null;
}

interface Signature {
  Args: PreviewSettingsModalArgs;
  Element: HTMLDivElement;
}

export default class PreviewSettingsModal extends Component<Signature> {
  @service declare intercomEventService: $TSFixMe;

  @tracked brandId: string | null = null;
  @tracked selectedUser: UserSummary | null | undefined = null;
  constructor(owner: unknown, args: PreviewSettingsModalArgs) {
    super(owner, args);
    this.brandId = args.currentBrandId;
    this.selectedUser = args.currentUser;
  }

  @action
  onSave() {
    this.args.onSave({
      user: this.selectedUser ?? null,
      brandId: this.brandId ?? null,
    });
    this.args.onClose();
  }

  @action
  onCancel() {
    this.brandId = this.args.currentBrandId;
    this.args.onClose();
  }

  @action
  handleBrandSelection(brandId: string | null) {
    this.brandId = brandId;
  }

  @action
  handleUserSelection(user: UserSummary | null) {
    this.selectedUser = user;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::Preview::Modals::PreviewSettingsModal': typeof PreviewSettingsModal;
    'workflows/preview/modals/preview-settings-modal': typeof PreviewSettingsModal;
  }
}
